export default {
    confirm: 'Yes, delete now',
    content: 'You are deleting the work space <u>including</u> the micro- and macro-trends as well as existing search agents for all participants.',
    notice: 'Attention: This action cannot be undone.',
    success: 'The work space was successfully deleted.',
    title: 'Are you sure you want to delete the work space "{title}" ?'
}
